<template>
  <div class="runtime-container">
    <highcharts
      class="chart"
      :options="chartOptions"
    />
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import formatCycleRuntime from '../../lib/formatter/formatCycleRuntime';

export default {
  name: 'RuntimeGraph',
  props: {
    graphData: Array,
    status: String,
    type: String,
  },
  data() {
    const runtimeData = [];
    const cycleDate = [];
    const placeholderData = [];
    const color = this.status === 'Watching' ? '#FFAB00' : '#FF5B52';
    const newGraphData = _.cloneDeep(this.graphData);
    const sortedData = newGraphData.sort((a, b) => moment(a.startTime).diff(b.startTime));

    sortedData.forEach((c) => {
      const {
        cycleTimeSeconds,
        startTime,
      } = c;

      if (startTime && cycleTimeSeconds) {
        runtimeData.push(cycleTimeSeconds);
        placeholderData.push(10000);
        cycleDate.push(moment(startTime).format('M/D/YY h:mm:ss a'));
      }
    });

    return {
      runtimeData,
      cycleDate,
      placeholderData,
      color,
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          spacingTop: 0,
          spacingBottom: 0,
          spacingLeft: 0,
          spacingRight: 0,
          height: 360,
          width: 470,
          events: {
            load() {
              this.seriesGroup.element.insertBefore(
                this.yAxis[0].gridGroup.element,
                this.series[0].markerGroup.element,
              );
            },
          },
          backgroundColor: 'transparent',
        },
        title: {
          text: '',
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          style: {
            display: 'none',
          },
          animation: false,
        },
        exporting: {
          enabled: false,
        },
        xAxis: {
          categories: this.cycleDate,
          lineWidth: 0,
          labels: {
            formatter() {
              const label = this.value;
              const date = moment(label).format('M/D/YY');
              const time = moment(label).format('hh:mm:ss A');
              return `${date}<br>${time}`;
            },
          },
        },
        yAxis: [{
          gridLineColor: 'white',
          gridLineDashStyle: 'Dash',
          gridLineWidth: 0,
          title: {
            text: '',
          },
          labels: {
            enabled: false,
          },
          min: 0,
          max: 86400,
        }],
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderRadius: 5,
            width: 10,
            dataLabels: {
              enabled: true,
              align: 'center',
              y: 1000,
              color: 'black',
              formatter() {
                return formatCycleRuntime(this.y);
              },
              style: {
                textOutline: 0,
                zIndex: 6,
                fontWeight: 'bold',
                fontSize: 15,
              },
            },
          },
          column: {
            stacking: 'normal',
          },
        },
        series: [{
          type: 'column',
          data: this.runtimeData,
          pointWidth: 30,
          color: this.color,
          yAxis: 0,
          xAxis: 0,
        }, {
          type: 'column',
          data: this.placeholderData,
          pointWidth: 30,
          color: 'white',
          yAxis: 0,
          xAxis: 0,
        }],
      };
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
